import { Divider } from '@deity/falcon-ui';
import { EntityDetailsHeader } from 'components/EntityDetails';
import VersionStatus from 'components/Package/StatusTab/VersionStatus';
import { CreateEditPackageModal } from 'components/Packages';
import { StatusBadge } from 'components/StatusBadge';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetPackageQuery, useGetPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

interface IStatusTabProps {
  isEditable?: boolean;
}

export const StatusTab: FC<IStatusTabProps> = ({ isEditable }) => {
  const { pathname } = useLocation();
  const params: { [key: string]: string } = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const [packageModalOpen, setPackageModalOpen] = useState<boolean>(false);

  const {
    loading: packageLoading,
    data: packageData,
    refetch
  } = useGetPackageQuery({
    variables: {
      uuid: params.packageId
    },
    skip: !params.packageId,
    ...CACHE_FIRST
  });
  if (!params.packageId) {
    // eslint-disable-next-line no-console
    console.log('StatusTab null');
  }
  const { data: packageVersionData, loading: versionLoading } = useGetPackageVersionQuery({
    variables: {
      uuid: params.versionUuid
    },
    skip: !params.versionUuid,
    ...CACHE_FIRST
  });

  const onPackageUpdated = () => {
    if (params?.packageId && refetch) {
      refetch({
        uuid: params?.packageId
      }).then();
    }
  };

  return params?.packageId && params?.versionUuid ? (
    <>
      <EntityDetailsHeader
        isEditable={isEditable}
        isLoading={packageLoading}
        name={packageData?.getPackage?.name}
        description={packageData?.getPackage?.description}
        onModalOpen={setPackageModalOpen}
        endEnhancer={<StatusBadge status={packageVersionData?.getPackageVersion?.status} />}
      />
      <Divider />
      <VersionStatus packageVersionData={packageVersionData} loading={versionLoading} />

      <CreateEditPackageModal
        isOpen={packageModalOpen}
        isEdit
        editPackage={packageData?.getPackage}
        setOpenState={state => setPackageModalOpen(state)}
        onPackageCreated={onPackageUpdated}
      />
    </>
  ) : null;
};
